<template>
  <div class="pm-box">
    <!-- 项目大厅 -->
    <el-tabs v-model="activeName" v-if="pmType === 1">
      <el-tab-pane label="采购公告" name="1">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="项目名称">
            <el-input size="medium" v-model="formInline.title1" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="onSubmit(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData1" style="width: 100%" v-if="pmType === 1">
          <el-table-column prop="title" label="项目名称" style="color: aqua;">
            <template slot-scope="scope">
              <div style="color: #1890FF;cursor: pointer;" @click="xMdetail(scope.row.id)">{{ scope.row.title }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="bid_type_name" label="采购形式"></el-table-column>

          <el-table-column prop="bid_price" label="限价"></el-table-column>

          <!-- localStorage.getItem('userInfo')).id -->
          <el-table-column prop="cate_name" label="类型"></el-table-column>
          <el-table-column prop="join_time" label="报名截止时间"></el-table-column>
          <el-table-column prop="inquiry_time" label="投标截止时间"></el-table-column>
        </el-table>

      </el-tab-pane>
      <el-tab-pane label="更正公告" name="3">
        <correct-notice v-if="activeName == 3"></correct-notice>
      </el-tab-pane>
      <el-tab-pane label="结果公告" name="2">
        <ResultNotice v-if="activeName == 2"></ResultNotice>
      </el-tab-pane>
      <el-tab-pane label="已结束" name="4">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="项目名称">
            <el-input size="medium" v-model="formInline.title2" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="onSubmit(2)">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData3" style="width: 100%" v-if="pmType === 1">
          <el-table-column prop=" title" label="项目名称" style="color: aqua;">
            <template slot-scope="scope">
              <div style="color: #1890FF;cursor: pointer;" @click="xMdetail(scope.row.id)">{{ scope.row.title }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="cate_name" label="类型"></el-table-column>
          <el-table-column prop="inquiry_time" label="投标截止时间"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>


    <!--已结束 -->
    <el-table :data="tableData3" style="width: 100%" v-if="pmType === 2">
      <el-table-column prop="title" label="项目名称" style="color: aqua;">
        <template slot-scope="scope">
          <div style="color: #1890FF;cursor: pointer;" @click="xMdetail(scope.row.id)">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cate_name" label="类型"></el-table-column>
      <el-table-column prop="inquiry_time" label="投标截止时间"></el-table-column>
    </el-table>
    <!-- 我参与 -->
    <el-table :data="tableData2" style="width: 100%" v-if="pmType === 3">
      <el-table-column prop="cate_name" label="项目名称">
        <template slot-scope="scope">
          <div style="color: #1890FF;cursor: pointer;" @click="xMdetail(scope.row.news_id)">{{ scope.row.cate_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="type_text" label="类型"></el-table-column>
      <el-table-column prop="remark_name" label="中标单位"></el-table-column>
      <el-table-column prop="inquiry_time" label="投标截止时间"></el-table-column>
      <el-table-column prop="intro" label="操作" style="color: aqua;">
        <template slot-scope="scope">
          <span style="color: #1890FF;margin-left: 5px;cursor: pointer;"
            @click="download(scope.row.news_id)">采购文件下载</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 项目详情 -->
    <el-dialog title="项目详情" width="80%" :visible.sync="detailsShow">
      <div>
        <el-form ref="form" :model="detailsData" label-width="140px" style="display: flex;flex-wrap: wrap;">
          <el-form-item label="项目名称:" style="width: 30%;"><el-input v-model="detailsData.title"
              disabled /></el-form-item>
          <!-- <el-form-item label="业务主体:" style="width: 30%;"><el-input v-model="detailsData.subject" disabled/></el-form-item> -->
          <el-form-item label="报名截止时间:" style="width: 30%;"><el-input v-model="detailsData.join_time"
              disabled /></el-form-item>
          <el-form-item label="投标截止时间:" style="width: 30%;"><el-input v-model="detailsData.inquiry_time"
              disabled /></el-form-item>
          <el-form-item label="开标时间:" style="width: 30%;"><el-input v-model="detailsData.open_time"
              disabled /></el-form-item>

          <el-form-item label="联系人:" style="width: 30%;"><el-input v-model="detailsData.contact"
              disabled /></el-form-item>
          <el-form-item label="联系电话:" style="width: 30%;"><el-input v-model="detailsData.mobile"
              disabled /></el-form-item>
          <el-form-item label="是否含税:" style="width: 30%;"><el-input v-model="detailsData.is_tax"
              disabled /></el-form-item>
          <el-form-item label="是否缴纳保证金:" style="width: 30%;"><el-input v-model="detailsData.is_margin"
              disabled /></el-form-item>
          <el-form-item label="附件信息:" style="width: 30%;"><el-input v-model="detailsData.attachment_desc"
              disabled /></el-form-item>
          <el-form-item label="投标限价:" style="width: 30%;"><el-input v-model="detailsData.bid_price"
              disabled /></el-form-item>
          <el-form-item label="招标方式:" style="width: 30%;"><el-input v-model="detailsData.bid_type"
              disabled /></el-form-item>
          <el-form-item label="项目说明:" style="width: 60%;"><el-input type="textarea" v-model="detailsData.project_desc"
              disabled /></el-form-item>
          <el-form-item label="附加说明:" style="width: 60%;"><el-input type="textarea"
              v-model="detailsData.attachment_desc" disabled /></el-form-item>
        </el-form>
        <el-button type="primary" @click="handleApplyShow"
          v-show="detailsData.is_baoming === 0 && pmType != 2">报名</el-button>
        <!-- <el-button type="primary" @click="download" v-show="detailsData.is_baoming === 1">下载全部附件</el-button> -->
        <!-- <el-button type="primary" @click="download">报名</el-button> -->
        <!-- <div class="tishi">温馨提示：如果下载全部附件查看提示压缩文件已损坏，请点击此链接下载正确文件压缩格式（360压缩）进行安装并查看那全部附件！</div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="detailsShow = false">关闭</el-button>
        <!-- <el-button type="primary" @click="detailsShow = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="报名" width="350px" :visible.sync="applyShow">
      <el-form :model="applyForm" :rules="rules" ref="applyForm" label-width="90px"
        style="display: flex;flex-wrap: wrap;">
        <el-form-item label="联系人" prop="name"><el-input v-model="applyForm.name" /></el-form-item>
        <el-form-item label="电话" prop="mobile"><el-input v-model="applyForm.mobile" /></el-form-item>
        <!-- <el-form-item  label="联系地址:" prop="address"><el-input v-model="applyForm.address" /></el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyShow = false">取 消</el-button>
        <el-button type="primary" @click="applySubmit" :loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api1, api2, api3, api4, apply } from '@/api/index.js'

import CorrectNotice from '@/components/CorrectNotice.vue'
import ResultNotice from '@/components/ResultNotice.vue'
export default {
  props: {
    pmType: {
      type: Number,
      default: 0 //1项目大厅 2.已结束 3.我参与的
    }
  },
  components: {
    CorrectNotice,
    ResultNotice
  },
  data() {
    return {
      id: '',
      activeName: '1',
      tableData1: [],
      tableData2: [],
      tableData3: [],
      formInline: {

        title1: '',
        title2: ''
      },
      detailsShow: false,
      zbDetailsShow: false,
      applyShow: false,
      applyForm: {},
      detailsData: {},
      nowIntro: '',
      btnLoading: false,
      rules: {
        name: [{ required: true, message: '请输入联系人名称', trigger: 'change' }],
        mobile: [{ required: true, message: '请输入联系人电话', trigger: 'change' }],
        address: [{ required: true, message: '请输入联系地址', trigger: 'change' }],
      }
    }
  },
  watch: {
    activeName() {
      this.formInline = {

        title1: '',
        title2: ''
      }

      if (this.pmType === 1) {
        // this.initial(1)
        // this.initial(2)
      }
      // if (this.pmType === 2) this.initial(2)
      if (this.pmType === 3) this.my()
    }
  },
  mounted() {

    this.$nextTick(() => {
      if (this.pmType === 1) {
        this.initial(1)
        this.initial(2)
      }
      // if (this.pmType === 2) this.initial(2)
      if (this.pmType === 3) this.my()
    })
  },
  methods: {
    seeDetails(intro) {
      this.nowIntro = intro
      this.zbDetailsShow = true
    },
    download(id) {
      api4({ id: id }).then(res => {
        // window.open(res.data.data.down_url)
        window.location.href = res.data.data.down_url
      })
    },
    xMdetail(id) {
      this.id = id
      api3({ id: id }).then(res => {
        if (res.data.code === 1) {
          this.detailsData = res.data.data
          this.detailsData.bid_type === 1 ? this.detailsData.bid_type = '公开招标' : this.detailsData.bid_type
          this.detailsData.is_tax === 1 ? this.detailsData.is_tax = '是' : '否'
          this.detailsData.is_margin === 1 ? this.detailsData.is_margin = '是' : '否'
          this.detailsShow = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleApplyShow() {
      this.applyForm = {}
      this.applyShow = true
      if (this.$refs['applyForm']) {
        this.$refs['applyForm'].clearValidate()
      }
      console.log(this.applyShow)
    },
    applySubmit() {
      let params = this.applyForm;
      params.id = this.detailsData.id;
      this.$refs['applyForm'].validate((valid) => {
        if (valid) {
          apply(params).then(res => {
            console.log(res)
            if (res.data.code === 1) {
              this.$message.success('报名成功')

              this.detailsShow = false
              this.$router.push({
                path: '/participant'
              })

            } else {
              this.$message.warning(res.data.msg)
            }
            this.btnLoading = false
            this.applyShow = false
          }).catch(err => {
            console.log(err)
            this.btnLoading = false
            this.$message.error('请求失败')

          })
        }
      });


    },
    my() {
      api2().then(res => {
        if (res.data.code === 1) {
          this.tableData2 = res.data.data.lists
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    initial(e) {
      api1({ type_id: e, title: this.formInline['title' + e] }).then(res => {
        let useId = JSON.parse(localStorage.getItem('userInfo')).id
        if (res.data.code === 1) {
          if (e === 1) {
            // res.data.data.lists
            this.tableData1 = res.data.data.lists.map(item => {
              console.log(item, 'itemitem', item.supplier, useId);
              item.bid_price = item.supplier.some(i => i === useId) ? item.bid_price + '万元' : '---'
              return item
            })
          } else {
            this.tableData3 = res.data.data.lists
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onSubmit(e) {
      if (e === 1) {
        this.initial(1)
      } else {
        this.initial(2)
      }

    }
  }

}
</script>

<style scoped>
.tishi {
  font-weight: 400;
  font-size: 14px;
  color: #E90000;
  margin-top: 20px;
}

.pm-box {
  width: 100%;
  height: 100%;
  padding: 10px 25px;
  box-sizing: border-box;
  background: #fff;
}

.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Cpm.vue